(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5229],{

/***/ 90586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform",
      function () {
        return __webpack_require__(96663);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 51313:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogoWhite.51bb8a67.svg","height":40,"width":162});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 96663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ platform; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/index.jsx + 10 modules
var Hero = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/landingPage/components/Section/index.jsx + 17 modules
var Section = __webpack_require__(1699);
// EXTERNAL MODULE: ./src/landingPage/components/Button/index.jsx + 3 modules
var Button = __webpack_require__(25504);
// EXTERNAL MODULE: ./src/landingPage/assets/svg/DemystLogoWhite.svg
var DemystLogoWhite = __webpack_require__(51313);
// EXTERNAL MODULE: ./src/landingPage/views/Platform/components/PlatformDiagram.module.less
var PlatformDiagram_module = __webpack_require__(15931);
var PlatformDiagram_module_default = /*#__PURE__*/__webpack_require__.n(PlatformDiagram_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/components/PlatformDiagram.jsx




var PlatformDiagram = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PlatformDiagram_module_default()).Diagram,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((PlatformDiagram_module_default()).Aside, (PlatformDiagram_module_default()).AsideLeft),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PlatformDiagram_module_default()).AsideContent,
                    children: "Any external data source, any frequency, any format"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((PlatformDiagram_module_default()).Line, (PlatformDiagram_module_default()).LineLeft)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PlatformDiagram_module_default()).Main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PlatformDiagram_module_default()).ArrowsOverlay,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PlatformDiagram_module_default()).Center,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Demyst",
                                src: DemystLogoWhite/* default.src */.Z.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PlatformDiagram_module_default()).ButtonContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PlatformDiagram_module_default()).ButtonColumn,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Tag,
                                                children: "Onboard"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Title,
                                                children: "Data and metadata"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Button,
                                                children: "Connectors"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PlatformDiagram_module_default()).ButtonColumn,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Tag,
                                                children: "Deploy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Title,
                                                children: "Workflows"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Button,
                                                children: "Data APIs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PlatformDiagram_module_default()).Button,
                                                children: "Data shares"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PlatformDiagram_module_default()).TagBottom,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (PlatformDiagram_module_default()).Tag,
                                            children: "Maintain"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PlatformDiagram_module_default()).List,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PlatformDiagram_module_default()).ListHeader,
                                    children: "Manage centrally"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Logs, monitoring and alerting"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Metadata management and data certification"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Platform security & compliance"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((PlatformDiagram_module_default()).Line, (PlatformDiagram_module_default()).LineRight)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((PlatformDiagram_module_default()).Aside, (PlatformDiagram_module_default()).AsideRight),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PlatformDiagram_module_default()).AsideContent,
                    children: "External data solutions"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/Customers.jsx
var Customers = __webpack_require__(45779);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityCard.module.less
var SecurityCard_module = __webpack_require__(79578);
var SecurityCard_module_default = /*#__PURE__*/__webpack_require__.n(SecurityCard_module);
;// CONCATENATED MODULE: ./src/landingPage/assets/SOC-logo.png
/* harmony default export */ var SOC_logo = ({"src":"/_next/static/media/SOC-logo.3c06d2bc.png","height":225,"width":226,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVDodZYkcl+yOo2mdPr8PdJl888kcvs+f3///85uOh9p9N31vSGstmPrtV21fMcj9BFhMIRgcc3eLsHe8QaicxNvuopseUYZ7Qnp94phskjb7gRquTaI7W6AAAAD3RSTlP8+/b8+Pv9+PD8+fjz+fimiNovAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBBwLAIAgEsFNRwA7cXf//ZxMI+5AyCVh7tVoIZy0Jc2ToW1LQ5aBXi7g/h623iGUHeI7HzBGEPeJO8gNkjALJVE4t/AAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/components/subcomponents/SecurityCard.jsx




var SecurityCard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SecurityCard_module_default()).SecurityCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SecurityCard_module_default()).Content,
                children: [
                    "We adhere to",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "GDPR"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "CCPA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "FCRA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "GLBA"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: SOC_logo.src,
                    width: 255,
                    height: 255,
                    alt: "SOC logo"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx + 2 modules
var SecurityBadges = __webpack_require__(69753);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/BottomCta.jsx
var BottomCta = __webpack_require__(72062);
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content.svg
/* harmony default export */ var Content = ({"src":"/_next/static/media/Content.619172b9.svg","height":431,"width":702});
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content-1.svg
/* harmony default export */ var Content_1 = ({"src":"/_next/static/media/Content-1.b5ae707a.svg","height":449,"width":702});
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content-4.svg
/* harmony default export */ var Content_4 = ({"src":"/_next/static/media/Content-4.db275d0f.svg","height":455,"width":700});
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content-5.svg
/* harmony default export */ var Content_5 = ({"src":"/_next/static/media/Content-5.c28da961.svg","height":441,"width":712});
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content-6.svg
/* harmony default export */ var Content_6 = ({"src":"/_next/static/media/Content-6.7142463a.svg","height":292,"width":570});
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/Content-7.svg
/* harmony default export */ var Content_7 = ({"src":"/_next/static/media/Content-7.4d317274.svg","height":186,"width":461});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/assets/platform_diagram.svg
/* harmony default export */ var platform_diagram = ({"src":"/_next/static/media/platform_diagram.91bd0d0c.svg","height":300,"width":414});
// EXTERNAL MODULE: ./src/landingPage/views/Platform/Platform.module.less
var Platform_module = __webpack_require__(30058);
var Platform_module_default = /*#__PURE__*/__webpack_require__.n(Platform_module);
;// CONCATENATED MODULE: ./src/landingPage/views/Platform/Platform.jsx


















var Platform = function() {
    var data = [
        {
            id: "Connectors",
            icon: fi/* FiLink */.XKb,
            title: "Connectors as a single interface to any upstream source",
            description: "Remove the complexity of managing different sources of data and their metadata by delivering a single, unified experience of connecting to any API, bulk file or stream"
        },
        {
            id: "Data APIs",
            icon: fi/* FiDatabase */.bGz,
            title: "Data APIs for real-time data access in production workflows",
            description: "Deploy a single connector or an orchestration of many together, as an API. Simply build with Demyst's proprietary configuration language, integrate through a standardised Demyst REST endpoint, and manage with in-built logging, monitoring and alerting"
        },
        {
            id: "Data Shares",
            icon: fi/* FiHardDrive */.mj,
            title: "Data shares for delivering bulk data into landing zones",
            description: "Rapidly access bulk files of data in your landing zone, configured to your needs with the format, schema, scheduling and more, such as as a Snowflake table share or into a AWS S3 bucket"
        },
        {
            id: "Configuration Gateway",
            icon: fi/* FiSettings */.nbt,
            title: "All managed through our Configuration Gateway APIs",
            description: "Simply manage and maintain complete visibility of all your data, through the configuration gateway. Managed through your own version control systems and access secured with multiple levels of controls"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* Hero */.VM, {
                background: "violet-800",
                withStarsAnimation: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* HeroCol */.Zx, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroTitle */.LR, {
                            children: "External Data Orchestration"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* CtaLinkButton */.k8, {
                            "data-test-id": "platform-hero-button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformDiagram, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers/* Customers */.S, {
                            withMargin: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                background: "blue-25",
                type: "two-col",
                masthead: {
                    title: "The Platform to manage all your external data"
                },
                reverse: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionList */.Xn, {
                                children: data.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionListItem */.PS, {
                                        icon: item.icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                                children: item.description
                                            })
                                        ]
                                    }, "".concat(item.id, "_").concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButton */.Qj, {
                                autoWidth: true,
                                href: "https://docs.demyst.com/",
                                variant: "inverted",
                                children: "Learn more in our docs"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        className: (Platform_module_default()).PlatformOverviewImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: platform_diagram.src,
                            alt: "",
                            width: "447",
                            height: "330",
                            layout: "responsive"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                type: "one-col",
                background: "coolGray-50",
                removeBottomPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionTitle */.NZ, {
                    children: "Powerful features that make the difference"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverseMobile: true,
                type: "two-col",
                background: "coolGray-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content.src,
                            alt: "",
                            width: "700",
                            height: "425"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "A standardized schema for external data"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Connectors remove the complexity of external data integration with standardised ingress, an automated LLM-enabled way of generating a standardised connection and relevant metadata for any upstream data source"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Leverages automatic schema detection to create data dictionaries and apply Demyst's attribute types that improve match rates"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Detect and flag anomalies when ingesting data to remove downstream risks"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverseMobile: true,
                type: "two-col",
                background: "white",
                reverse: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content_6.src,
                            alt: "",
                            width: "700",
                            height: "425"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "Metadata required for external data workflows"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Extensive connector metadata means remaining in control of your Data Hub and fostering data use. Access data dictionaries, performance statistics, usage logs, and governance metadata such as usage rights"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Integrates with other enterprise data catalogs such as Informatica, Collibra and Alation, simplifying metadata management"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverseMobile: true,
                type: "two-col",
                background: "coolGray-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content_1.src,
                            alt: "",
                            width: "700",
                            height: "425"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "External data resilience"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Use external data orchestration across multiple sources, creating a single Data API that optimizes for cost or includes redundancies with water-falling, failovers and more"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Avoid managing a complex array of endpoints by integrating with Demyst's standardised REST endpoint"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Automatically cache data you've already called to save on data costs"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverse: true,
                reverseMobile: true,
                type: "two-col",
                background: "white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content_4.src,
                            alt: "",
                            width: "600",
                            height: "380"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "Batch data workflows"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Easily schedule Data shares to access bulk data from multiple sources in your data lakes and warehouses"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: 'Reduce the time it takes to ingest and manipulate data into a workable data product. Transform upstream data from any source into the "agreed in advance" standardised format, naming conventions, encoding, record validation methods, retry mechanism and more'
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverseMobile: true,
                type: "two-col",
                background: "coolGray-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content_5.src,
                            alt: "",
                            width: "580",
                            height: "400"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "No more errant data with external data visibility"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Have complete control of all your data and its use, manage incidents with alerts, and ensure governance compliance. Fueled by detailed logging of all data movements"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Enterprise grade security functionality helps keep data security at the forefront, including SSO, MFA, user access controls, IP whitelists, and more"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Simplify support with a standardised error layer across all data sources. Trust in Demyst frontline support to triage and manage complex multi-provider incidents"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$0, {
                reverse: true,
                reverseMobile: true,
                type: "two-col",
                background: "white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionImage */.Pi, {
                            src: Content_7.src,
                            alt: "",
                            width: "580",
                            height: "400"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                type: "h3",
                                children: "Accelerated data licensing for Discovery"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionList */.Xn, {
                                size: "sm",
                                background: "blue-25",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Ensure there is a compliant path for business users to leverage for external data evaluation in a reasonable timeframe"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Derisk your data evaluation backlog. Demyst provides data procurement, due dilligence and ingestion services for evaluation data, completed to best practice standards"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionListItem */.PS, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                                            children: "Ensure compliance with proper data use by ingesting this information as Connector metadata"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                type: "one-col",
                background: "white",
                removeTopPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButton */.Qj, {
                    autoWidth: true,
                    href: "https://docs.demyst.com/",
                    variant: "inverted",
                    children: "Learn more in our docs"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "coolGray-100",
                type: "one-col",
                masthead: {
                    title: "Security you can trust",
                    subtitle: "Demyst is dedicated to secure and compliant data use to support critical business decisions. It maintains dedicated Security, Compliance, and IT teams that are empowered to act."
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionCol */.JZ, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityCard, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionParagraph */.Lo, {
                            type: "subheading",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "Demyst is SOC 2 Type II Certified and maintains an information security program based on established security standards such as ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: " NIST 800-53"
                                        }),
                                        " and",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "ISO 27001"
                                        }),
                                        "."
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-800",
                type: "one-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta/* BottomCta */.W, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-1000",
                removeBottomPadding: true,
                removeTopPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityBadges/* SecurityBadges */.U, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
;// CONCATENATED MODULE: ./pages/platform/index.jsx




var PlatformPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/platform",
                title: meta/* meta.platform.title */.$.platform.title,
                description: meta/* meta.platform.description */.$.platform.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Platform, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var platform = (PlatformPage);


/***/ }),

/***/ 50183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt.png
/* harmony default export */ var Momnt = ({"src":"/_next/static/media/Momnt.30635708.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////zk3/////3v7Xzm4j3xb6ROC7wAAAAB3RSTlNYYkBNaG5HZO0z8gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABlJREFUeJwFwQcBAAAIAyDm6x9ZQJ0WsSPxAPEAGZmuqSMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/CincinnatiFinance.png
/* harmony default export */ var CincinnatiFinance = ({"src":"/_next/static/media/CincinnatiFinance.4bb80e30.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXEUVG0aVWwASmoAT2sAVVXFqwtiAAAABnRSTlMAKDMNUgYUvz2rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nG3LsREAMAyDQIGc/VfOuTfNVyRH2qXOQJMiwEsQ5Xg+BykAMrwb8LsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/NAB.svg
/* harmony default export */ var NAB = ({"src":"/_next/static/media/NAB.b100bc4e.svg","height":425,"width":875});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers-color.svg
var Farmers_color = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered-color.svg
var StandardChartered_color = __webpack_require__(18378);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz-color.svg
var Anz_color = __webpack_require__(15968);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt-color.png
/* harmony default export */ var Momnt_color = ({"src":"/_next/static/media/Momnt-color.a6d59b53.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUQLlgUMFd9WWjfg3OLX2kaM1nQfXFqAiexAAAAB3RSTlNcVEdAaGluDzj5NwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGRkZmJgZGRgYGBgY2FkZWAAAADeABp7a5gYAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/constants/CustomerLogos.js





// import IAG from "../landingPage/views/assets/logos/IAG.png";





var logos = {
    default: [
        {
            src: NAB.src,
            alt: "NAB",
            width: "150",
            height: "60"
        },
        {
            src: Anz/* default.src */.Z.src,
            alt: "ANZ",
            width: "100",
            height: "35",
            isAnz: true
        },
        {
            src: Momnt.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        },
        {
            src: StandardChartered/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Farmers/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        // { src: IAG.src, alt: "IAG", width: "80", height: "80" },
        {
            src: CincinnatiFinance,
            alt: "Cincinnati",
            width: "120",
            height: "120",
            isBrightLogo: true
        }, 
    ],
    color: [
        {
            src: Anz_color/* default.src */.Z.src,
            alt: "ANZ",
            width: "96",
            height: "31"
        },
        {
            src: Farmers_color/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        {
            src: StandardChartered_color/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Momnt_color.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        }, 
    ]
};


/***/ }),

/***/ 72062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ BottomCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1699);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25504);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67039);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__);




var BottomCta = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().divReadyToGetStarted),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_1__/* .SectionHeading */ .OT, {
                        type: "h2",
                        children: "Ready to get started?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().lestUsSectionColor),
                        children: "See why our customer continue to trust and leverage Demyst to accelerate their external data initiatives."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .CtaLinkButton */ .k8, {
                    autoWidth: true,
                    classNameDiv: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsButton),
                    className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsText),
                    text: "Let us show you how"
                })
            })
        ]
    });
};


/***/ }),

/***/ 45779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Customers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48900);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Customers_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50183);





var Customers = function(param) {
    var className = param.className, _header = param.header, header = _header === void 0 ? "Join the customers already unlocking the power of external data with Demyst:" : _header, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _align = param.align, align = _align === void 0 ? "center" : _align, _withMargin = param.withMargin, withMargin = _withMargin === void 0 ? false : _withMargin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().Customers), withMargin && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersMargin), align === "center" && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersAlignCenter), className),
        children: [
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersHeader),
                style: {
                    marginBottom: "40px"
                },
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlider),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosTrack),
                    children: Array(2).fill().map(function() {
                        var ref;
                        return (ref = _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__/* .logos */ .U[variant]) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlide), i.isBrightLogo && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().BrightLogo)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    priority: false,
                                    src: i.src,
                                    alt: i.alt,
                                    width: i.width,
                                    height: i.height
                                })
                            }, i.alt);
                        });
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 69753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ SecurityBadges; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/components/Badge/Badge.module.less
var Badge_module = __webpack_require__(86919);
var Badge_module_default = /*#__PURE__*/__webpack_require__.n(Badge_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/components/Badge/Badge.jsx




var Badge = function(param) {
    var icon = param.icon, _background = param.background, background = _background === void 0 ? "violet-1000" : _background, children = param.children;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    var iconToShow = icon ? typeof icon === "function" ? icon() : typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: icon,
        alt: ""
    }) : null : typeof icon === "object" ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCheckCircle */._rq, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Badge_module_default()).Badge, (Badge_module_default())[backgroundClassName]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Badge_module_default()).BadgeIcon,
                children: iconToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Badge_module_default()).BadgeLabel,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Badge/index.jsx


// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.module.less
var SecurityBadges_module = __webpack_require__(68760);
var SecurityBadges_module_default = /*#__PURE__*/__webpack_require__.n(SecurityBadges_module);
;// CONCATENATED MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx



var SecurityBadges = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SecurityBadges_module_default()).SecurityBadges,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "SOC 2 Type II"
                    }),
                    " Certified"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GDPR"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "CCPA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FCRA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GLBA"
                    }),
                    " Compliant"
                ]
            })
        ]
    });
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 86919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__XqccE","blue_800":"Badge_blue_800__umxh_","blue_900":"Badge_blue_900__B9XkS","blue_1000":"Badge_blue_1000__UZDMq","violet_1000":"Badge_violet_1000__So3zY","BadgeLabel":"Badge_BadgeLabel__vt7Tn"};

/***/ }),

/***/ 67039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BottomCta":"BottomCta_BottomCta__VRmZc","lestUsSectionColor":"BottomCta_lestUsSectionColor__cKutT","letUsText":"BottomCta_letUsText__TbXdV","divReadyToGetStarted":"BottomCta_divReadyToGetStarted__nkl4j","letUsButton":"BottomCta_letUsButton__0YB3K","BottomCtaCol":"BottomCta_BottomCtaCol__xDN69","BottomCtaList":"BottomCta_BottomCtaList__1rBcr","BottomCtaListItem":"BottomCta_BottomCtaListItem__Ojioj"};

/***/ }),

/***/ 48900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Customers":"Customers_Customers__4fdox","CustomersMargin":"Customers_CustomersMargin__LJDSh","CustomersHeader":"Customers_CustomersHeader__6lKvo","CustomersLogosSlider":"Customers_CustomersLogosSlider__XT3_j","CustomersLogosTrack":"Customers_CustomersLogosTrack__u_0zQ","trackslide":"Customers_trackslide__HouPN","CustomersLogosSlide":"Customers_CustomersLogosSlide__UUzik","BrightLogo":"Customers_BrightLogo__dFg_w"};

/***/ }),

/***/ 68760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SecurityBadges":"SecurityBadges_SecurityBadges__RilZo"};

/***/ }),

/***/ 79578:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SecurityCard":"SecurityCard_SecurityCard__sVoaB","Content":"SecurityCard_Content__s9Avi"};

/***/ }),

/***/ 30058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ResourcesCol":"Platform_ResourcesCol__XalLj","PlatformOverviewImage":"Platform_PlatformOverviewImage__8_Enz"};

/***/ }),

/***/ 15931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Diagram":"PlatformDiagram_Diagram__ign53","Main":"PlatformDiagram_Main___pIM2","ArrowsOverlay":"PlatformDiagram_ArrowsOverlay__cO5JQ","Aside":"PlatformDiagram_Aside__NJIr2","AsideLeft":"PlatformDiagram_AsideLeft__fxXrX","AsideRight":"PlatformDiagram_AsideRight__tCAG1","AsideContent":"PlatformDiagram_AsideContent__glxRN","Line":"PlatformDiagram_Line__b2WKs","LineLeft":"PlatformDiagram_LineLeft__TBuaP","LineRight":"PlatformDiagram_LineRight__vrLOU","Center":"PlatformDiagram_Center__rdNv6","Title":"PlatformDiagram_Title__xAkud","ButtonContainer":"PlatformDiagram_ButtonContainer__VBnya","Tag":"PlatformDiagram_Tag__dz7p4","TagBottom":"PlatformDiagram_TagBottom__y7bNL","ButtonColumn":"PlatformDiagram_ButtonColumn__o5wrv","Button":"PlatformDiagram_Button__DlH5W","List":"PlatformDiagram_List__oBEWL","ListHeader":"PlatformDiagram_ListHeader__8i8Z_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,5675,9223,4280,9774,2888,179], function() { return __webpack_exec__(90586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);